import {
  Token,
  TokenInfo,
  TokenMetadata,
} from '@/generated/proto/bridge/models/token'
import { ProtobufAnyMessage } from '@/types'

export interface InsertTokenFormValues {
  creator: string
  token: {
    id: string
    metadata: {
      name: string
      symbol: string
      uri: string
      dexName?: string
    }
    info?: TokenInfo[]
  }
}

export interface UpdateTokenFormValues {
  creator: string
  selectedTokenId?: string
  tokenId: string
  metadata: {
    name: string
    symbol: string
    uri?: string
    dexName?: string
  }
}

export interface DeleteTokenFormValues {
  creator: string
  tokenId: string
}

export function buildInsertTokenMessage(values: InsertTokenFormValues): {
  messages: ProtobufAnyMessage[]
} {
  const tokenPayload: Token = {
    id: values.token.id,
    metadata: {
      name: values.token.metadata.name,
      symbol: values.token.metadata.symbol,
      uri: values.token.metadata.uri ?? '',
      dexName: values.token.metadata.dexName ?? '',
    },
    info: values.token.info ?? [],
  }

  return {
    messages: [
      {
        '@type': '/core.bridge.MsgInsertToken',
        creator: values.creator,
        token: tokenPayload,
      },
    ],
  }
}

export function buildUpdateTokenMessage(values: UpdateTokenFormValues): {
  messages: ProtobufAnyMessage[]
} {
  const metadata: TokenMetadata = {
    name: values.metadata.name,
    symbol: values.metadata.symbol,
    uri: values.metadata.uri ?? '',
    dexName: values.metadata.dexName ?? '',
  }

  return {
    messages: [
      {
        '@type': '/core.bridge.MsgUpdateToken',
        creator: values.creator,
        tokenId: values.tokenId,
        metadata,
      },
    ],
  }
}

export function buildDeleteTokenMessage(values: DeleteTokenFormValues): {
  messages: ProtobufAnyMessage[]
} {
  return {
    messages: [
      {
        '@type': '/core.bridge.MsgDeleteToken',
        creator: values.creator,
        tokenId: values.tokenId,
      },
    ],
  }
}
